import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Shield, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const field = 'w-full px-4 py-2.5 bg-slate-900/50 border border-slate-700 rounded-lg text-white placeholder-slate-500 text-sm';
const errText = (d) => (typeof d === 'string' ? d : Array.isArray(d) ? 'Revisa los datos ingresados (mínimo 8 caracteres)' : 'Ocurrió un error, intenta de nuevo');

const Shell = ({ title, children }) => (
  <div className="min-h-screen bg-slate-950 flex items-center justify-center px-4">
    <div className="w-full max-w-md bg-slate-900 border border-slate-800 rounded-2xl p-8 space-y-5">
      <div className="flex items-center gap-2"><Shield className="w-7 h-7 text-blue-500" /><span className="text-white font-bold text-lg">NotaryOS</span></div>
      <h1 className="text-2xl font-bold text-white">{title}</h1>
      {children}
      <Link to="/auth" data-testid="back-to-login-link" className="block text-sm text-blue-400 hover:underline">Volver a iniciar sesión</Link>
    </div>
  </div>
);

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState('');
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const r = await axios.post(`${API}/auth/forgot-password`, { email }); setDone(r.data.message); }
    catch (er) { toast.error(errText(er.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <Shell title="Recuperar contraseña">
      {done ? <p data-testid="forgot-done" className="text-sm text-emerald-300">{done}</p> : (
        <form onSubmit={submit} className="space-y-3">
          <p className="text-sm text-slate-400">Te enviaremos un enlace válido por 1 hora.</p>
          <input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@email.com" className={field} />
          <button data-testid="forgot-submit-btn" disabled={busy} className="w-full btn-primary py-2.5 flex justify-center">{busy ? <Loader2 className="w-5 h-5 animate-spin" /> : 'Enviar enlace'}</button>
        </form>
      )}
    </Shell>
  );
}

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error('Las contraseñas no coinciden');
    setBusy(true);
    try {
      const r = await axios.post(`${API}/auth/reset-password`, { token: params.get('token') || '', new_password: pw });
      toast.success(r.data.message); navigate('/auth');
    } catch (er) { toast.error(errText(er.response?.data?.detail)); } finally { setBusy(false); }
  };
  if (!params.get('token')) {
    return (
      <Shell title="Enlace inválido">
        <p data-testid="reset-invalid-link" className="text-sm text-slate-300">Este enlace no es válido o está incompleto. <Link to="/recuperar-clave" className="text-blue-400 underline">Solicita uno nuevo</Link>.</p>
      </Shell>
    );
  }
  return (
    <Shell title="Nueva contraseña">
      <form onSubmit={submit} className="space-y-3">
        <input data-testid="reset-password-input" type="password" required minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Nueva contraseña (mín. 8)" className={field} />
        <input data-testid="reset-password-confirm-input" type="password" required minLength={8} value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Repite la contraseña" className={field} />
        <button data-testid="reset-submit-btn" disabled={busy} className="w-full btn-primary py-2.5 flex justify-center">{busy ? <Loader2 className="w-5 h-5 animate-spin" /> : 'Guardar contraseña'}</button>
      </form>
    </Shell>
  );
}
